import React from 'react';
import { FileText, ArrowRight, Trash2, Plus, Clock, Disc3 } from 'lucide-react';
import { formatNotificationTime } from '../../lib/notificationService';

export default function DraftRecoveryModal({ drafts, onSelectDraft, onDeleteDraft, onStartNew }) {
  if (!drafts || drafts.length === 0) return null;

  return (
    <div className="dist-card" style={{ border: '1px solid rgba(217, 251, 6, 0.35)', background: 'rgba(217, 251, 6, 0.04)' }}>
      <div className="dist-card-header" style={{ borderColor: 'rgba(217, 251, 6, 0.2)' }}>
        <div>
          <h3 className="dist-card-title" style={{ color: '#d9fb06' }}>
            <FileText size={20} /> Unfinished Release Drafts Detected
          </h3>
          <p className="dist-card-desc">
            You have {drafts.length} saved unfinished release draft{drafts.length > 1 ? 's' : ''}. You can resume where you left off or start a fresh submission.
          </p>
        </div>

        <button
          type="button"
          className="dist-btn-primary"
          style={{ padding: '0.45rem 1rem', fontSize: '0.85rem' }}
          onClick={onStartNew}
        >
          <Plus size={15} /> Start New Release
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
        {drafts.map((draft) => {
          const trackCount = draft.draftData?.audioTracks?.length || (draft.draftData?.tracks?.length || 1);
          return (
            <div
              key={draft.id}
              style={{
                background: 'rgba(0, 0, 0, 0.25)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
                padding: '1.2rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: '1rem',
              }}
            >
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.4rem' }}>
                  <h4 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#ffffff', margin: 0 }}>
                    {draft.title || 'Untitled Release'}
                  </h4>
                  <span className="dist-track-num-pill">
                    {draft.releaseType?.toUpperCase() || 'SINGLE'}
                  </span>
                </div>

                <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
                  <span className="dist-tech-chip">
                    <Disc3 size={12} style={{ display: 'inline', marginRight: 3 }} /> {trackCount} {trackCount === 1 ? 'Track' : 'Tracks'}
                  </span>
                  <span className="dist-tech-chip">
                    Step {draft.currentStep || 1} of 5
                  </span>
                  <span className="dist-tech-chip" style={{ color: 'rgba(255,255,255,0.5)' }}>
                    <Clock size={12} style={{ display: 'inline', marginRight: 3 }} /> {formatNotificationTime(draft.updatedAt)}
                  </span>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '0.8rem', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                <button
                  type="button"
                  className="dist-btn-primary"
                  style={{ padding: '0.4rem 0.9rem', fontSize: '0.82rem' }}
                  onClick={() => onSelectDraft(draft)}
                >
                  Continue Release <ArrowRight size={14} />
                </button>

                <button
                  type="button"
                  className="dist-remove-btn"
                  onClick={() => onDeleteDraft(draft)}
                  title="Delete Draft"
                >
                  <Trash2 size={15} />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
